import { IPage, ISearchPage } from '@/types/AppTypes'
import { httpRequest } from '@/utils/HttpRequest'
import { getBaseCiRequestUrl, getToken } from '@/utils/constants'

//详情
export interface IMessageDetail {
    id?: string
    prefix?: string
    shopId?: string
    shopCode?: string
    shopName?: string
    branch?: string
    ver?: string
    enable?: string
    orgCode?: string
    orgName?: string
    contact?: string
    phone?: string
    address?: string
    status?: number | boolean
    sourceApp?: string
    categoryName?: string
    typeCode?: string
    typeName?: string
    suffixNum?: number
    settingType?: string
    isYear?: number
    isMonth?: number
    isDate?: number
    style?: string
    note?: string
    orderNum?: number
    traceId?: string
    deleteFlag?: number
    createTime?: string
    updateTime?: string
    createUser?: string
    updateUser?: string
    [key: string]: any
}
//新增
export interface IMessageInsert {
    /**
     * 所属业务编码
     */
    businessTypeCode: string
    /**
     * 所属业务名称
     */
    businessTypeName: string
    /**
     * 通知方式
     */
    informMode?: null | string
    /**
     * 通知周期
     */
    informPeriod: string
    /**
     * 通知时间
     */
    informTime?: null | string
    /**
     * 通知类型
     */
    informType: string
    /**
     * 站内主题
     */
    instationSubject?: null | string
    /**
     * 公众号主题
     */
    officialAccountSubject?: null | string
    /**
     * 推送类型
     */
    pushType: string
    /**
     * 规则名称
     */
    settingName: string
    /**
     * 短信主题
     */
    smsSubject?: null | string
    /**
     * 触发条件
     */
    triggeringCondition?: null | string
    /**
     * 预警分类编码
     */
    warningTypeCode: string
    /**
     * 预警分类名称
     */
    warningTypeName: string
    [property: string]: any
}

//编辑
export interface IMessageUpdate extends IMessageInsert {
    id?: string
}
//搜索条件
export interface IMessageSearchFields {
    settingType?: string
    id?: string
}

export interface IMessageSearch extends IMessageSearchFields, ISearchPage {
    shopId?: string
    shopCode?: string
}

export interface IpositionSearch extends IMessageSearchFields, ISearchPage { }

class MessageService {
    async page(searchVo: IMessageSearch, config: object = {}) {
        const apiUrl = '/yh-franchisee/messageSetting/listPage'
        return await httpRequest.post<IPage<IMessageDetail>>(apiUrl, searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }
    async one(id: string) {
        const apiUrl = `/yh-franchisee/messageSetting/select/${id}`
        return await httpRequest.get<IMessageDetail>(apiUrl, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }
    async insert(insertVo: IMessageInsert) {
        const apiUrl = '/yh-franchisee/messageSetting/insert'
        return await httpRequest.post<boolean>(apiUrl, insertVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }
    async update(updateVo: IMessageUpdate) {
        const apiUrl = '/yh-franchisee/messageSetting/update'
        return await httpRequest.post<boolean>(apiUrl, updateVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }
    async unreadNum() {
        const apiUrl = `/yh-franchisee/message/unreadNum`
        return await httpRequest.get<number>(apiUrl, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }
}

export const messageService = new MessageService()
